import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import ReactTable from 'react-table';
import _ from 'lodash';
import { Checkbox } from 'semantic-ui-react';
import { withRouter } from 'react-router';

import { NotificationMessage } from 'Components';
import { caseInsensitiveFilter } from 'Common/GridHelper';
import { Filter, Main } from 'Containers';
import * as constants from 'Common/Constants';

import * as actions from './state/actions';

const title = 'Assign License';

class AssignLicenseContainer extends Component {
  componentWillMount() {
    this.props.getLicenseAssignSite('SiteMaster?allSites=true');
    this.props.getControlInfoLicenseCount();
  }

  onToggle = (row) => {
    this.props.updateLicenseAssignSiteCollection(row);
  };

  onSaveClick = () => {
    const { postLicenseAssignSiteUpdate, licenseAssignSite } = this.props;

    postLicenseAssignSiteUpdate(licenseAssignSite.Data)
      .then((result) => {
        NotificationMessage(result);
      })
      .catch((err) => {
        NotificationMessage(err);
      });
  };

  licensedVsAsssigned = () => {
    const { licenseCount, licenseAssignSite } = this.props;
    return (
      (isNaN(licenseCount.Data) ? 0 : licenseCount.Data) -
      _.filter(licenseAssignSite.Data, (d) => d.IsLicensed).length
    );
  };

  getMainProps = () => {
    const { loading, isReadOnly } = this.props;

    return {
      toolbox: {
        rightButtons: [
          {
            loading,
            content: 'Save',
            disabled: loading || isReadOnly,
            onClick: this.onSaveClick,
          },
        ],
        shown: true,
      },
    };
  };

  renderGrid() {
    const { loading, licenseAssignSite, isReadOnly } = this.props;

    const columns = [
      {
        Header: 'Site ID',
        accessor: 'Id',
        maxWidth: 100,
        filterable: true,
      },
      {
        Header: 'Description',
        accessor: 'Description',
        filterable: true,
      },
      {
        Header: (
          <span>
            Licensed
            <br />
            <strong>Remaining</strong> <br />
            {this.licensedVsAsssigned()}
          </span>
        ),
        accessor: 'IsLicensed',
        maxWidth: 120,
        Cell: ({ original }) => {
          return (
            <div style={{ textAlign: 'center' }}>
              <Checkbox
                checked={original.IsLicensed === true}
                disabled={isReadOnly}
                onChange={() => this.onToggle(original)}
              />
            </div>
          );
        },
      },
    ];

    return (
      <Fragment>
        <Filter title={title} />
        <Main {...this.getMainProps()}>
          <ReactTable
            minRows={0}
            data={licenseAssignSite.Data}
            className={'-striped -highlight grid--fixed-row-height'}
            defaultFilterMethod={caseInsensitiveFilter}
            columns={columns}
            pageSizeOptions={[5, 10, 15, 20, 25, 50, 100]}
            defaultPageSize={15}
            noDataText={
              !loading && licenseAssignSite.Data.length === 0
                ? 'No Data Found'
                : ''
            }
            loading={loading}
            getTrProps={(state, rowInfo, column) => {
              return {
                style: {
                  color:
                    rowInfo &&
                    rowInfo.original &&
                    rowInfo.original.IsActive === true
                      ? ''
                      : 'red',
                },
              };
            }}
          />
        </Main>
      </Fragment>
    );
  }

  render() {
    const { loading, licenseCount, licenseAssignSite } = this.props;

    if (!loading && licenseCount.Data === 0) {
      return (
        <div>
          <Filter title={title} />
          <Main>
            <p>You do not have an installed licenses for this product. </p>
            <p>
              Please go <Link to="/license">here</Link> to import your license
              file.
            </p>
          </Main>
        </div>
      );
    }

    if (
      licenseAssignSite.CountErrors &&
      licenseAssignSite.CountErrors.length > 0
    ) {
      return (
        <div>
          <Filter title={title} />
          <Main>
            <p>
              {`Your database has not been setup correctly.  ${constants.TECHNICAL_SUPPORT_VERBIAGE}`}
            </p>
          </Main>
        </div>
      );
    }

    return this.renderGrid();
  }
}

const mapStateToProps = ({ AssignLicenseState }) => {
  return {
    licenseCount: AssignLicenseState.licenseCount,
    licenseAssignSite: AssignLicenseState.licenseAssignSite,
    loading: AssignLicenseState.loading,
  };
};

export const AssignLicense = withRouter(
  connect(mapStateToProps, actions)(AssignLicenseContainer)
);



// WEBPACK FOOTER //
// ./src/pages/assignlicense/AssignLicense.js